var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZaf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icon-css-za",
    width: 640,
    height: 480,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    d: "M-71.9 0h682.7v512H-71.9z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "translate(67.4) scale(.93748)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-71.9 407.8V104.4L154 256.1-72 407.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00c",
    d: "M82.2 512.1l253.6-170.6H696V512H82.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M66 0H696v170.8H335.7S69.3-1.7 66 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M-71.9 64v40.4L154 256-72 407.8v40.3l284.5-192L-72 64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#093",
    d: "M-71.9 64V0h95l301.2 204h371.8v104.2H324.3L23 512h-94.9v-63.9l284.4-192L-71.8 64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23 0h59.2l253.6 170.7H696V204H324.3L23 .1zm0 512.1h59.2l253.6-170.6H696v-33.2H324.3L23 512z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZaf);
export default __webpack_public_path__ + "static/media/zaf.0386a651cf88fc6217d8cf96b14ab44d.svg";
export { ForwardRef as ReactComponent };